/**
 * @generated SignedSource<<0d2649d72e7ee897503af6306897af89>>
 * @relayHash 29f4b2d809a01ced534f7f051bb93454
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 72da5660a34e56d364c736238a62c9df9a96bd06bc1b4bfc3a62dc90f78077d0

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TopNavigationQuery$variables = {
  atlassianAccountId: string;
  cloudId: string;
  collabContextRoutingAri?: string | null;
  isAnonymous: boolean;
  isNavStateQuerySkipped: boolean;
  issueKey: string;
  projectIdOrKey: string;
  projectKey: string;
  shouldCheckProjectType: boolean;
  shouldCheckProjectTypeForIssue: boolean;
  shouldFetchCSMLiveChatAgent: boolean;
  shouldFetchProjectType: boolean;
  shouldFetchProjectTypeForSettingsAndEA: boolean;
  skipHelpButtonRelayRead: boolean;
};
export type TopNavigationQuery$data = {
  readonly jira?: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EditionAwareness_query" | "HelpButtonUserProperty_query" | "Nav4NotificationsData" | "ProductHomeWithQuery" | "ProfileNew" | "SettingsAction_query">;
};
export type TopNavigationQuery = {
  response: TopNavigationQuery$data;
  variables: TopNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextRoutingAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavStateQuerySkipped"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectType"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectTypeForIssue"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchCSMLiveChatAgent"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectType"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectTypeForSettingsAndEA"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipHelpButtonRelayRead"
},
v14 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v17 = [
  {
    "kind": "Variable",
    "name": "collabContextRoutingAri",
    "variableName": "collabContextRoutingAri"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "Variable",
  "name": "accountId",
  "variableName": "atlassianAccountId"
},
v20 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v21 = [
  {
    "kind": "ScalarField",
    "name": "projectType"
  },
  (v18/*: any*/)
],
v22 = [
  {
    "args": [
      (v14/*: any*/),
      {
        "kind": "Variable",
        "name": "idOrKey",
        "variableName": "projectIdOrKey"
      }
    ],
    "concreteType": "JiraProject",
    "kind": "LinkedField",
    "name": "jira_projectByIdOrKey",
    "plural": false,
    "selections": (v21/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TopNavigationQuery",
    "selections": [
      {
        "condition": "isNavStateQuerySkipped",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v15/*: any*/),
                "concreteType": "JiraNavigationUIStateUserProperty",
                "kind": "LinkedField",
                "name": "navigationUIState",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProfileNew"
          },
          {
            "args": (v17/*: any*/),
            "kind": "FragmentSpread",
            "name": "Nav4NotificationsData"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "ProductHomeWithQuery"
      },
      {
        "kind": "FragmentSpread",
        "name": "EditionAwareness_query"
      },
      {
        "kind": "FragmentSpread",
        "name": "SettingsAction_query"
      },
      {
        "condition": "skipHelpButtonRelayRead",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HelpButtonUserProperty_query"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v12/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v13/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopNavigationQuery",
    "selections": [
      {
        "condition": "isNavStateQuerySkipped",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v15/*: any*/),
                "concreteType": "JiraNavigationUIStateUserProperty",
                "kind": "LinkedField",
                "name": "navigationUIState",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v19/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  }
                ],
                "type": "AtlassianAccountUser"
              },
              (v18/*: any*/)
            ]
          },
          {
            "condition": "shouldFetchProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v22/*: any*/)
          },
          {
            "condition": "shouldFetchCSMLiveChatAgent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v19/*: any*/),
                  (v14/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "csm_liveChatAgent",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "liveChatActivity"
                      },
                      {
                        "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                        "kind": "LinkedField",
                        "name": "liveChatActivitiesBySpace",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "concreteType": "CustomerServiceSpaceLiveChatActivity",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "activityStatus"
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CustomerServiceLiveChatAgent"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "identifier"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "errorType"
                          }
                        ]
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "args": (v17/*: any*/),
                "kind": "ScalarField",
                "name": "unseenNotificationCount"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldCheckProjectTypeForIssue",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v14/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                  }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      },
                      (v18/*: any*/)
                    ]
                  },
                  (v18/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldCheckProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v14/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "projectKey"
                  }
                ],
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": (v21/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldFetchProjectTypeForSettingsAndEA",
        "kind": "Condition",
        "passingValue": true,
        "selections": (v22/*: any*/)
      },
      {
        "condition": "skipHelpButtonRelayRead",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v14/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "propertyKey",
                    "value": "help_button_ui_state"
                  }
                ],
                "concreteType": "JiraEntityPropertyJSON",
                "kind": "LinkedField",
                "name": "jsonUserProperty",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "jsonValue"
                  },
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "72da5660a34e56d364c736238a62c9df9a96bd06bc1b4bfc3a62dc90f78077d0",
    "metadata": {},
    "name": "TopNavigationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dc8153f923b9c46dab724112d3410d51";

export default node;
